import { render, staticRenderFns } from "./uc-menu-icon.vue?vue&type=template&id=86a93386&scoped=true"
import script from "./uc-menu-icon.vue?vue&type=script&lang=ts"
export * from "./uc-menu-icon.vue?vue&type=script&lang=ts"
import style0 from "./uc-menu-icon.vue?vue&type=style&index=0&id=86a93386&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a93386",
  null
  
)

export default component.exports